import Loader from 'Component/Loader';

const renderTable = (args, callback, instance) => {
    return (
        <>
            { callback() }
            { instance.renderValidationMessage() }
        </>
    )
}

const renderValidationMessage = (args, callback, instance) => {
    switch(instance.props.validationState) {
        case 'CERTIFIED':
            return (
                <div block="Notification" mods={ { type: 'success', isValidation: true } }>
                    <p block="Notification" elem="Text">
                        { __('The delivery address was successfully validated.') }
                    </p>
                </div>
            );
        case 'VALID':
            return (
                <div block="Notification" mods={ { type: 'info', isValidation: true } }>
                    <p block="Notification" elem="Text">
                        { __('The delivery address is valid but could not be verified. Please check that the delivery address is correct and then continue.') }
                    </p>
                </div>
            );
        case 'NOT VALID':
            return (
                <div block="Notification" mods={ { type: 'error', isValidation: true } }>
                    <p block="Notification" elem="Text">
                        { __('The validation of the delivery address has shown that it is invalid. Please check the correctness of the delivery address before you continue.') }
                    </p>
                </div>
            );
        case 'ERROR':
            return (
                <div block="Notification" mods={ { type: 'error', isValidation: true } }>
                    <p block="Notification" elem="Text">
                        { __('An error occurred during the validation of the delivery address.') }
                    </p>
                </div>
            );
    }
    return null;
}

const render = (args, callback, instance) => {
    const { countries, mix } = instance.props;

    return (
        <div block="MyAccountAddressTable" mix={ mix }>
            <Loader isLoading={ !countries.length } />
            { instance.renderTable() }
            { instance.renderActions() }
        </div>
    );
}

export default {
    'Component/MyAccountAddressTable/Component': {
        'member-function': {
            renderTable,
            renderValidationMessage,
            render
        }
    }
}
